// Libraries, etc
import './plugins/composition-api';
import './plugins/vuetify';
import './plugins/vuex';
import './plugins/axios';
import './plugins/hotkeys';

import Vue from 'vue';

import { restoreSession } from '@/common/auth';

// App
import App from './App.vue';
import router from './router';
import store from './store';


Vue.config.productionTip = false;


// Restore session, if possible.
restoreSession().finally(() => {
  new Vue({
    router,
    store,
    // vuetify,
    render: h => h(App),
  }).$mount('#app');
});
